// Environment configuration for zWarehouse
// This handles environment detection and configuration

// Get the current environment
const getEnvironment = () => {
    // Check for explicit environment variable
    if (process.env.REACT_APP_ENVIRONMENT) {
        return process.env.REACT_APP_ENVIRONMENT;
    }
    
    // Check NODE_ENV (Create React App sets this)
    if (process.env.NODE_ENV) {
        return process.env.NODE_ENV;
    }
    
    // Default to development
    return 'development';
};

// Check if we're in a specific environment
export const isDevelopment = () => getEnvironment() === 'development';
export const isStaging = () => getEnvironment() === 'staging';
export const isProduction = () => getEnvironment() === 'production';

// Check if credentials should be shown
export const shouldShowCredentials = () => {
    const env = getEnvironment();
    
    // Always show in development
    if (env === 'development') {
        return true;
    }
    
    // Never show in production
    if (env === 'production') {
        return false;
    }
    
    // In staging, only show if explicitly enabled
    if (env === 'staging') {
        return process.env.REACT_APP_SHOW_CREDENTIALS === 'true';
    }
    
    // Default to false for any other environment
    return false;
};

// Get current environment info for debugging
export const getEnvironmentInfo = () => {
    return {
        environment: getEnvironment(),
        nodeEnv: process.env.NODE_ENV,
        reactAppEnvironment: process.env.REACT_APP_ENVIRONMENT,
        showCredentials: process.env.REACT_APP_SHOW_CREDENTIALS,
        shouldShowCredentials: shouldShowCredentials()
    };
};

// Export the main function
export default getEnvironment; 